import React from 'react';
import SignupForm from '../components/Auth/SignupForm';
import './Authpage.css';

function SignupPage() {
  return (
    <div className="auth-page">
      <SignupForm />
    </div>
  );
}

export default SignupPage;
